import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { LookupItemPicker, LookupItemPickerUserPropsType } from './LookupItemPicker'
import { objectToLookup } from '../helpers/miscFunctions'

export type TreatmentExpensesPickerProps = Omit<LookupItemPickerUserPropsType, 'lookupItems'> & {
  expensesType: string
}
export const TreatmentExpensesPicker = (props: TreatmentExpensesPickerProps) => {
  const { expensesType, ...rest } = props
  const { t } = useTranslation()

  const lookup = useMemo(() =>
    objectToLookup(t(`treatmentExpensesType.${expensesType}`, { returnObjects: true }))
    , [expensesType, t]
  )
  return <LookupItemPicker {...rest} lookupItems={lookup}
  />

}
